export const footerplugin = (editor, opts = {}) => {
  const labels = {
    block1: true,
  }

  const categories = {
    category1: 'Footers',
  }

  opts = { labels: labels, categories: categories }
  loadComponents(editor, opts)
}

const loadComponents = (editor, options) => {
  const { categories } = options
  const blcks = editor.config.pluginsOpts.footers
  blcks.map((blk, blkInd) => {
    editor.BlockManager.add('block' + blkInd, {
      label: blk.themeFooterName,
      category: categories.category1,
      content: `${blk.themeFooterHTML}`,
    })
  })
}
